import { render, staticRenderFns } from "./RigDataTable.vue?vue&type=template&id=6bad7093&scoped=true"
import script from "./RigDataTable.vue?vue&type=script&lang=ts"
export * from "./RigDataTable.vue?vue&type=script&lang=ts"
import style0 from "./RigDataTable.vue?vue&type=style&index=0&id=6bad7093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad7093",
  null
  
)

export default component.exports